import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import * as usertypes from '@account/store/types'
import { mapGetters, mapActions } from 'vuex'
import { openPopup } from '@appbase/util/popup-helper'
import api from '@gnb/api'

// components
import GnbSearch from '@gnb/components/GlobalNavigationBarLeft/GnbSearch.vue'
import GnbWorkFeed from '@gnb/components/GlobalNavigationBarLeft/GnbWorkFeed.vue'
import GnbBookmark from '@gnb/components/GlobalNavigationBarLeft/GnbBookmark.vue'
import GnbSiteMap from '@gnb/components/GlobalNavigationBarLeft/GnbSiteMap.vue'
import GnbQuickMenu from '@gnb/components/GlobalNavigationBarLeft/GnbQuickMenu.vue'
import menuHelper from '@appbase/util/menu-helper'

import SubGlobalNavigationBar from '@gnb/components/GlobalNavigationBar/SubGlobalNavigationBar.vue'
import PreferenceModal from '@gnb/components/Preference/PreferenceModal.vue'
import modalHelper from '@appbase/util/modal-helper'
import * as accountTypes from '@account/store/types'

import FloatingChat from '@appbase/components/Custom/FloatingChat/FloatingChat.vue'

@Component({
    components: {
        SubGlobalNavigationBar,
        GnbSearch,
        GnbWorkFeed,
        GnbBookmark,
        GnbSiteMap,
        GnbQuickMenu,
        FloatingChat
    },
    computed: {
        ...mapGetters({
            userCurrent: usertypes.CURRENT,
        }),
    },
    methods: {
        ...mapActions({
            logout: accountTypes.LOGOUT,
        }),
    },
})
export default class GnbTop extends Vue {
    userCurrent!: account.TCurrent
    siteMapItems: appbase.cache.TMenuItem[] = []
    menuPermission: account.TPermissionMenu[] = []
    userLang: string = ''

    // Components Data
    searchCounts: Array<number> = [0, 0, 0]
    orgList: orgmap.UserItem[] = []
    articleList: gnbarticle.Article[] = []
    //전자결재 아이템 추가
    workflowList: Array<gnbTotalSearch.workflowSearchItems> = []
    workFeedItems: gnb.WorkFeedItem[] = []
    bookMarkItems: gnb.BookMarkItem[] = []
    quickMenuItems: gnb.QuickMenuItem[] = []


    // 검색 관련
    searchkeyword: string = ''
    searchselected: boolean = false

    // 알림 관련
    UnReadWorkFeedStatus: boolean = false

    // Gnb Item Display Option
    dispGnbSearch: boolean = false
    dispGnbWorkFeed: boolean = false
    dispGnbBookmark: boolean = false
    dispGnbSitemap: boolean = false
    dispGnbQuickMenu: boolean = false;

    //메뉴관련
    menuItems: appbase.cache.TMenuItem[] = []
    isAdmin: boolean = false
    isMailOnly: boolean = false
    personCode: string = ''
    comCode: string = ''
    payType: string = ''
    payTypeGubun: string = ''

    //Top UserInfo
    displayName: string = ""
    titleName: string = ""
    displayDeptName: string = ""

    //겸직자
    is_concurrent_active: boolean = false;

    //관리자 url
    adminUrl: string = ""

    fnGoHome() {
        menuHelper.goHome()
    }

    // 검색창 Display 열기
    fnOpenGnbSearch(event: string) {
        this.dispGnbSearch = event == 'O' ? true : false
        this.dispGnbWorkFeed = false
        this.dispGnbBookmark = false
        this.dispGnbSitemap = false
        this.dispGnbQuickMenu = false

        if (event == 'O') {
            this.orgList = []
            this.articleList = []
            this.workflowList = []
            this.searchCounts = [0, 0, 0]
            this.searchselected = false
        }
    }

    // Gnb 검색 옵션
    fnSelectedGnbSearch(event: any)
    {
        //debugger
        // var result:Boolean =  event.target.checked 
        this.searchselected = event.target.checked
    }

    // Gnb 검색
    async fnGnbSearch(event: KeyboardEvent) {
        if (event) event.preventDefault()

        const keyword = (<HTMLInputElement>document.getElementById('txtGnbSearch')).value
        const keywordOption = this.searchselected

        //글자수 제한으로 어느정도 부하 줄임
        if (keyword.length < 2) {
            await(window as any).alertAsync(this.$t('검색어는_2글자').toString())
            return
        }
        this.searchkeyword = keyword

        //검색전 이전 데이터 초기화 
        this.orgList = []
        this.articleList = []
        this.workflowList = []
        this.searchCounts = [0, 0, 0]


        // keyword: string
        // pageNumber: number
        // pagePerCount: number
        // include: Array<string>
        api.totalSearch.totalSearch({
            keyword: keyword,
            keywordOption: keywordOption,
            pageNumber: 1,
            pagePerCount: 5,
            include: ["workflow", "board", "orgchart"]
        }).then(result => {
            this.orgList = result.orgItems
            this.articleList = result.boardItems.data
            this.workflowList = result.workflowItems.items


            this.searchCounts = []
            this.searchCounts.push(result.orgItems.length)
            this.searchCounts.push(result.boardItems.totalCount)
            this.searchCounts.push(result.workflowItems.totalCount)
        })



        return





        let keyWord = (<HTMLInputElement>document.getElementById('txtGnbSearch')).value
        this.searchkeyword = keyWord
        // 검색 데이터 초기화
        this.orgList = []
        this.articleList = []
        this.workflowList = []

        // 조직 데이터 검색
        var orgOption = {
            query: keyWord,
            includeAllFlag: false,
            retiredFlag: false
        } as gnborgmap.SearchOptions
        api.gnb.searchOrg(orgOption, this.userCurrent.company.comCode).then((res: any) => {
            const { items, totalCount } = res;
            if (items) {
                this.orgList = items;
            }
        });

        // 게시판 데이터 검색
        var boardOption = {
            userCode: this.userCurrent.user.personCode,
            includeContent: true,
            useNotice: false,
            page: 1,
            itemsPerPage: 5,
            searchField: 30,
            searchFieldValue: keyWord,
            sortField: 0,
            sortOrder: false
        } as gnbarticle.TotalArticleSearchSet
        api.gnb.getTotalArticles(boardOption).then((res: any) => {
            const { data, totalCount } = res;
            if (data) {
                this.articleList = data;
            }
        });


    }

    fnMoreSearch(searchType: string) {

        if (window.location.href.toLowerCase().indexOf('/workflow/') != -1) // 결재의 경우 절대경로로 지정합니다
        {
            var url = window.location.protocol + '//' + window.location.host + window.location.port + 
            '/po/home/search?SearchText=' + this.searchkeyword + '&Target=' + searchType + '&SearchOption=' + this.searchselected;
            
            window.location.href = url;
        }
        else {
            this.$router.push({
                name: 'total-search',
                query: {
                    SearchText: this.searchkeyword,
                    SearchOption: this.searchselected.toString(),
                    Target: searchType
                }
            }).catch(() => {

            });
        }
        this.fnOpenGnbSearch('C');
    }

    openModal() {
        modalHelper.show({ component: PreferenceModal, force: true, value: { isMailOnly: this.isMailOnly } })
    }

    // 조직도 Open
    fnOrgPop() {
        openPopup(
            'gnb',
            '/orgmap',
            { event: 'OrgPopup', option: { personal: false, public: false, single: true } },
            {
                width: 1024,
                height: 700,
                isFrame: this.isTeams
            }
        )
    }

    // Workfeed
    fnOpenGnbWorkFeed(event: string) {
        this.dispGnbSearch = false
        this.dispGnbWorkFeed = event == 'O' ? true : false
        this.dispGnbBookmark = false
        this.dispGnbSitemap = false
        this.dispGnbQuickMenu = false

        if (event == 'O') {
            // Workfeed 데이터 조회
            this.fnGetWorkFeedList()
        }
    }

    logout!: () => Promise<void>
    handleLogoff() {
        this.logout();
    }
    // WorkFeed 데이터 조회
    fnGetWorkFeedList() {
        api.gnb
            .getWorkFeedList(this.userCurrent.user.personCode, this.userCurrent.user.comCode)
            .then((res: any) => {
                if (res) {
                    this.workFeedItems = res
                } else {
                    this.workFeedItems = []
                }

                this.UnReadWorkFeedStatus = (this.workFeedItems.length > 0 ? true : false);
            })
    }

    // 읽지 않은 WorkFeed 건수 조회
    fnGetUnreadWorkFeedCount() {
        api.gnb
            .getWorkFeedUnreadCount(this.userCurrent.user.personCode, this.userCurrent.user.comCode)
            .then((res: any) => {
                this.UnReadWorkFeedStatus = res > 0 ? true : false
            })
    }

    // WorkFeed Item Click
    fnReadWorkfeed(workfeedItem: gnb.WorkFeedItem) {
        // Link가 존재하는 경우 호출
        if (workfeedItem.itemUrl != '') {
            var noinvalidateUrl = false;
            switch (workfeedItem.alarmType) {
                case 'WF':
                    noinvalidateUrl = true;
                    break;
            }
            this.fnOpenWindow(workfeedItem.itemUrl, workfeedItem.alarmText, 1024, 900, noinvalidateUrl);
        }

        api.gnb.setWorkFeedReadStatus(workfeedItem.alarmId, true).then((res: any) => {
            if (res > -1) {
                let nIdx = this.workFeedItems.findIndex((x) => x.alarmId == workfeedItem.alarmId)
                if (nIdx > -1) this.workFeedItems.splice(nIdx, 1)
                if (this.workFeedItems.length == 0) this.UnReadWorkFeedStatus = false
            }
        })
    }

    // 즐겨찾기 Display
    fnOpenGnbBook(event: string) {
        this.dispGnbSearch = false
        this.dispGnbWorkFeed = false
        this.dispGnbBookmark = event == 'O' ? true : false
        this.dispGnbSitemap = false
        this.dispGnbQuickMenu = false

        if (event == 'O') {
            this.fnGetBookMarkList()
        }
    }

    // 즐겨찾기 목록 조회
    fnGetBookMarkList() {
        api.gnb
            .getBookMarkList(this.userCurrent.user.personCode, this.userCurrent.user.comCode)
            .then((res: any) => {
                if (res) {
                    this.bookMarkItems = res
                } else {
                    this.bookMarkItems = []
                }
            })
    }

    // 즐겨찾기 클릭 이벤트 처리
    async fnBookmarkClick(bookmarkItem: gnb.BookMarkItem) {
        if (bookmarkItem) {
            if (bookmarkItem.itemId) {
                // itemId의 경우 menuId 값이며, menuId가 존재할 경우 menuHelper를 실행한다.
                let item: appbase.cache.TMenuItem | null = menuHelper.findOne(bookmarkItem.itemId);
                if (item) {
                    this.fnOpenGnbBook('C');
                    menuHelper.next(item);
                }
                else {
                    // 즐겨찾기된 메뉴가 삭제된 경우
                    let msg = this.$t('즐겨찾기_메뉴_없음_알림').toString() + '\r\n' + this.$t('삭제하시겠습니까').toString()
                    if (await(window as any).confirmAsync(msg)) {
                        this.delBookmarkItem(bookmarkItem, true);
                    }
                }
            }
            else {
                if (bookmarkItem.itemUrl != '') {
                    switch (bookmarkItem.itemType) {
                        case 'MU':
                            document.location.href = bookmarkItem.itemUrl
                            break
                        case 'FO':
                            this.fnOpenGnbBook('C');
                            this.fnOpenWindow(bookmarkItem.itemUrl, bookmarkItem.itemText, 1024, 900)
                            break
                    }
                }
            }
        }
    }

    async delBookmarkItem(bookmarkItem: gnb.BookMarkItem, isConfirm: boolean = false) {
        if (!isConfirm) isConfirm = await(window as any).confirmAsync(this.$t('삭제하시겠습니까').toString())

        if (isConfirm) {
            api.gnb.deleteBookMark(bookmarkItem.bookMarkId, this.userCurrent.user.personCode, this.userCurrent.company.comCode).then((res: any) => {
                if (res > -1) {
                    this.fnGetBookMarkList();
                }
            });
        }
    }

    fnOpenGnbSiteMap(event: string) {
        this.dispGnbSearch = false
        this.dispGnbWorkFeed = false
        this.dispGnbBookmark = false
        this.dispGnbSitemap = event == 'O' ? true : false
        this.dispGnbQuickMenu = false
    }

    async fnSiteMapClick(siteMap: appbase.cache.TMenuItem) {
        if (siteMap.targetUrl) {
            this.fnOpenGnbSiteMap('C')
            menuHelper.next(siteMap)
        }
        else {
            if (siteMap.hasChildren && siteMap.children.length > 0 && siteMap.children[0].targetUrl) {
                this.fnOpenGnbSiteMap('C')
                menuHelper.next(siteMap.children[0])
            }
            else if (siteMap.children[0].hasChildren && siteMap.children[0].children.length > 0 && siteMap.children[0].children[0].targetUrl) {
                this.fnOpenGnbSiteMap('C')
                menuHelper.next(siteMap.children[0].children[0])
            }
            else if (siteMap.children[0].children[0].hasChildren && siteMap.children[0].children[0].children.length > 0 && siteMap.children[0].children[0].children[0].targetUrl) {
                this.fnOpenGnbSiteMap('C')
                menuHelper.next(siteMap.children[0].children[0].children[0])
            }
            else {
                await(window as any).alertAsync(this.$t('메뉴_등록된_URL_없음').toString())
            }
        }
    }

    // 퀵메뉴 Open 설정
    fnOpenGnbQuickMenu(event: string) {
        this.dispGnbSearch = false;
        this.dispGnbWorkFeed = false;
        this.dispGnbBookmark = false;
        this.dispGnbSitemap = false;
        this.dispGnbQuickMenu = (event == 'O' ? true : false)
    }

    // 퀵메뉴 목록 조회
    fnGetQuickMenuItems() {
        api.gnb.getUserQuickMenuList(this.userCurrent.user.personCode, this.userCurrent.company.comCode,
            this.userCurrent.user.employeeNumber,
            this.userCurrent.user.displayName, this.userCurrent.user.payType, this.userCurrent.user.payTypeGubun, 'U').then((res: any) => {
            if (res) {
                this.quickMenuItems = res;
            }
        });
    }

    fnInsertQuickMenuUserSet(quickMenuIds: string) {
        api.gnb.insertQuickMenuUserSet(this.userCurrent.user.personCode, this.userCurrent.user.comCode, quickMenuIds).then(async (res: any) => {
            if (res > -1) {
                await(window as any).alertAsync(this.$t('저장_하였습니다').toString());
                this.fnGetQuickMenuItems();
            }
            else {
                await(window as any).alertAsync(this.$t('저장_실패').toString());
            }
        });
    }

    // 퀵메뉴 클릭 이벤트 처리
    fnQuickMenuClick(item: gnb.QuickMenuItem) {
        if (item) {
            const { title, linkUrl, moveType, width, height } = item            
            

            // 퀵매뉴 db에도 박혀있는 부분이라 확인 필요
            if(title == '그룹러닝센터' || linkUrl.indexOf(this.getAppConfig('MultiCampersUrl') || '') > -1){
                let keydata={linkKey:'',publicKey:''};
                const tenant : string = this.getAppConfig('MultiCampersTenantId') || '20917'
                const apiurl : string = this.getAppConfig('MultiCampersApiUrl') || 'https://interface.multicampus.com/org/v1/user/public/lcsso/login'
                api.gnb.initMulticapmersSsoInit(apiurl,tenant).then(async (res: any) => {
                    
                    if( res.code == 'SUCCESS'){
                        
                        keydata = res.data
                        //Cipher c = Cipher.getInstance("AES/CBC/PKCS5Padding");

                        //aes.aesEncrypt() '@appbase/util/aes-encrypt' 에 있으나 전용 유틸인거 같아 별도로 사용
                        const crypto = require('crypto-browserify')
                        
                        let utf8Encode = new TextEncoder();
                        let bufiv = utf8Encode.encode(keydata.publicKey);
                        //256은 key 32자리줘야함, 16자리주고잇음 
                        //만일 keydata.publicKey가 32자리로오면 16자리로 잘라서 bufiv에 넣어주고 aes-256-CBC으로 변경
                        const encryptedCbcBuffer = crypto.createCipheriv('aes-128-CBC',keydata.publicKey ,bufiv);                       
                        encryptedCbcBuffer.setAutoPadding(true);
                        let hmac = encryptedCbcBuffer.update(keydata.linkKey+'|'+tenant, 'utf8', 'base64');
                        hmac += encryptedCbcBuffer.final('base64');
                        
                        let cono = this.userCurrent.user.employeeNumber + this.userCurrent.user.comCode                
                        api.gnb.initMulticapmersSsoBody(apiurl,hmac,keydata.linkKey,cono).then(async (res: any) => {
                            
                            if( res.code == 'SUCCESS'){
                                let ssotoken = res.data
                                window.open(this.getAppConfig('MultiCampersUrl')+'?token='+ssotoken, '_blank');                                       


                            }else{
                                
                                window.open('https://lc.multicampus.com/isu', '_blank');          
                                
                            }
                            
                        }).catch((err : any)=>{
                            console.log('initMulticapmersSsoBody err',err)                            
                            
                            window.open('https://lc.multicampus.com/isu', '_blank');          
                        }).finally(()=>{
                            setTimeout(function(){
                                api.gnb.initMulticapmersSsoEnd(apiurl,hmac,keydata.linkKey)
                            }, 5000);
                        });
                    }else{
                                
                        window.open('https://lc.multicampus.com/isu', '_blank');          
                        
                    }
                    
                }).catch((err : any)=>{
                    console.log('initMulticapmersSsoInit err',err)
                    window.open('https://lc.multicampus.com/isu', '_blank');          
                });
            }else{
                if (linkUrl) {
                    switch (moveType) {
                        case 0:     // 페이지 이동
                            document.location.href = linkUrl.toString()
                            break;
                        case 1:     // 새탭으로 열기
                            window.open(linkUrl.toString(), '_blank');
                            break;
                        case 2:     // 팝업
                            this.fnOpenWindow(linkUrl.toString(), title.toString(), Number(width), Number(height));
                            break;
                    }
                }
            }
            
        }
    }

    fnOpenWindow(url: string, title: string, width: number = 1024, height: number = 900, noinvalidateUrl = false) {
        if (url != '') {
            // let nWidth = width ? width : 1024
            // let nHeight = height ? height : 900
            // let nLeft = (screen.width - nWidth) / 2
            // let nTop = (screen.height - nHeight) / 2
            // let property =
            //     'left=' +
            //     nLeft +
            //     ',top=' +
            //     nTop +
            //     ',height=' +
            //     nWidth +
            //     ',width=' +
            //     nHeight +
            //     ',toolbar=no,scrollbars=no,resizable=yes'
            // window.open(url, title, property)

            openPopup(
                title,
                url,
                {},
                {
                    width: width,
                    height: height,
                    toolbar: 0,
                    scrollbars: 'no',
                    resizable: 1,
                    isFrame: this.isTeams,
                    noinvalidateUrl: noinvalidateUrl
                }
            )
        }
    }

    // 메뉴 데이터 생성
    fnMakeMenuItem(
        childItems: appbase.cache.TMenuItem[],
        item: appbase.cache.TMenuItem,
        itemType: string
    ) {
        for (let i = 0; i < childItems.length; i++) {
            let isPermission =
                (itemType == 'S' ? true : childItems[i].isTopVisible) &&
                    this.menuPermission.find((x) => x.id == childItems[i].menuId)
                    ? true
                    : false && childItems[i].callType == 'USER'

            if (isPermission && childItems[i].hasChildren) {
                this.fnMakeMenuItem(childItems[i].children, childItems[i], itemType)
            }

            if (i == 0) {
                item.children = []
                item.hasChildren = false
            }
            if (isPermission) {
                item.children.push(childItems[i])
            }
        }

        if (item.children.length > 0) {
            item.hasChildren = true
        }
    }

    selectUser(item: account.User) {
        // 선택한 겸직으로 활성
        if ((window as any).eumLoadingBefore) {
            (window as any).eumLoadingBefore();
        }
        api.common.setConcurrentUserDeptCode(item.personCode, item.deptCode).then((res) => {
            window.location.reload();
        }).catch((err) => {
            if ((window as any).eumLoadingAfter) {
                (window as any).eumLoadingAfter(null, err);
            }
            console?.log(err);
        });
    }

    mounted() {

    }

    created() {
        const { menu } = this.portalCache
        const excepts = ['HOME', 'MYPAGE']
        let mItems: appbase.cache.TMenuItem[] = menuHelper.setMenuParam(menu.items, this.userCurrent.user)
        this.menuPermission = this.userCurrent.permissions.menues

        // 관리자 여부 및 사용자 정보
        this.isAdmin =
            this.userCurrent.permissions.isSuperAdmin || this.userCurrent.permissions.isCompanyManager
                ? true
                : false
        this.isMailOnly = this.userCurrent.user.deptCode.indexOf('MAILONLY') > -1 ? true : false
        this.personCode = this.userCurrent.user.personCode
        this.comCode = this.userCurrent.user.comCode

        this.adminUrl = "/admin"
        //회사자원 및 공용자원 관리 권한
        if(this.userCurrent.permissions.isReserveManager || this.userCurrent.permissions.isGlobalReserveManager){
            this.adminUrl = "/admin/reservedb/category"
            this.isAdmin = true
        }
        
        //팝업관리권한
        if(this.userCurrent.permissions.isPopupManager){
            this.adminUrl = "/admin/func/noticepopup"
            this.isAdmin = true
        }

        //게시판 관리 권한
        if(this.userCurrent.permissions.isBoardManager){
            this.adminUrl = "/admin/board-admin/boardSetting/general"
            this.isAdmin = true
        }

        //계정 관리
        if(this.userCurrent.permissions.isGroupwareAccountManager){
            this.adminUrl = "/admin/hr/proxyPage"
            this.isAdmin = true
        }
       
        for (let i = 0; i < mItems.length; i++) {
            let mItem: appbase.cache.TMenuItem = mItems[i]

            if (
                mItem.isTopVisible == true &&
                mItem.callType == 'USER' &&
                this.menuPermission.find((x) => x.id == mItem.menuId)
            ) {
                this.menuItems.push(mItem)
                if (mItem.hasChildren) {
                    this.fnMakeMenuItem(mItem.children, mItem, 'M')
                }
            }

            if (
                !excepts.includes(mItem.callType) &&
                this.menuPermission.find((x) => x.id == mItem.menuId)
            ) {
                this.siteMapItems.push(mItem)
                if (mItem.hasChildren) {
                    this.fnMakeMenuItem(mItem.children, mItem, 'S')
                }
            }


        }

        // 다국어 설정
        this.userLang = this.userCurrent.userConfig.language

        // 다국어 설정
        this.userLang = this.userCurrent.userConfig.language
        if (this.userLang && this.userLang == 'ko-KR') {
            this.displayName = this.userCurrent.user.displayName
            this.titleName = this.userCurrent.user.titleName
            this.displayDeptName = this.userCurrent.user.deptName
        }
        else {
            this.displayName = this.userCurrent.user.displayNameEng
            this.titleName = this.userCurrent.user.titleNameEn
            this.displayDeptName = this.userCurrent.user.deptNameEn
        }



        // Workfeed 데이터 건수 조회
        this.fnGetUnreadWorkFeedCount()
        // 퀵메뉴 데이터 조회
        this.fnGetQuickMenuItems()
    }

    fnUserDisplay(user: account.TUser, type: 0 | 1 | 2 | 3) {
        var lang = this.userLang?.toLowerCase();
        var company = this.userCurrent.company;
        switch (lang) {
            case 'ko-kr':
                switch (type) {
                    case 0: // 이름
                        return user.displayName;
                    case 1: // 직책
                        return user.titleName;
                    case 2: // 부서
                        return user.deptName;
                    case 3: // 계열사
                        return company.companyName;
                }
                break;
            default:
                switch (type) {
                    case 0: // 이름
                        return user.displayNameEng;
                    case 1: // 직책
                        return user.titleNameEn;
                    case 2: // 부서
                        return user.deptNameEn;
                    case 3: // 계열사
                        return company.companyNameEng;
                }
                break;
        }
        switch (type) {
            case 0: // 이름
            case 1: // 직책
            case 2: // 부서
            case 3: // 계열사
        }
    }

    fnGnbClick(item: appbase.cache.TMenuItem) {
        //menuHelper.next(item)
        if (item) {
            // Menu URL이 있는 경우 Menu 이동
            if (item.targetUrl) {
                menuHelper.next(item)
            } else {
                if (item.hasChildren && item.children.length > 0 && item.children[0].targetUrl) {
                    menuHelper.next(item.children[0])
                }
                else if (item.children[0].hasChildren && item.children[0].children.length > 0 && item.children[0].children[0].targetUrl) {
                    menuHelper.next(item.children[0].children[0])
                }
                else if (item.children[0].children[0].hasChildren && item.children[0].children[0].children.length > 0 && item.children[0].children[0].children[0].targetUrl) {
                    menuHelper.next(item.children[0].children[0].children[0])
                }
            }
        }
    }
}
